import React, { useState } from 'react';
import {
  FormControl,
  FormLabel,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Collapse,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const FormInputs = ({
  selectedDate,
  setSelectedDate,
  modelList,
  setModelList,
  modelOptions = [],
  numberOfQuestions,
  setNumberOfQuestions,
  notifiedUserEmail,
  setNotifiedUser,
  evaluationCriteria,
  setEvaluationCriteria,
  evaluationCriteriaOptions = ['generation'],
}) => {
  const controlled =
    typeof setEvaluationCriteria === 'function' &&
    Array.isArray(evaluationCriteria);

  const [internalCriteria, setInternalCriteria] = useState([]);
  const criteria = controlled ? evaluationCriteria : internalCriteria;
  const updateCriteria = controlled ? setEvaluationCriteria : setInternalCriteria;

  const handleCriteriaChange = (e) => {
    const { name, checked } = e.target;
    updateCriteria(
      checked ? [...criteria, name] : criteria.filter((c) => c !== name)
    );
  };

  const [showHelp, setShowHelp] = useState(false);

  return (
    <Box>
      {/* Help toggle */}
      <Box display="flex" alignItems="center" justifyContent="flex-end" sx={{ mb: 1 }}>
        <Typography variant="body2" sx={{ mr: 1 }}>
          Help
        </Typography>
        <IconButton onClick={() => setShowHelp(!showHelp)} size="small">
          <HelpOutlineIcon fontSize="small" />
        </IconButton>
      </Box>

      {/* Collapsible Help Section */}
      <Collapse in={showHelp}>
        <Box sx={{ mb: 3, p: 2, border: '1px dashed gray', borderRadius: 2, backgroundColor: '#f9f9f9' }}>
          <Typography variant="body2" gutterBottom>
            <strong>Latest date for questions</strong>: Questions will be sampled from interactions that happened before this date.
          </Typography>
          <Typography variant="body2" gutterBottom>
            <strong>Select model(s)</strong>: Choose questions regarding specific customer model(s)
          </Typography>
          <Typography variant="body2" gutterBottom>
            <strong>Number of questions</strong>: Total questions to submit in the batch. Must be a positive integer.
          </Typography>
          <Typography variant="body2" gutterBottom>
            <strong>Send notification to</strong>: (Optional) Your Aquant email - You'll get a slack message with updates and a link to view the results
          </Typography>
        </Box>
      </Collapse>

      {/* Form Fields */}
      <FormControl fullWidth sx={{ mb: 2 }}>
        <FormLabel>Latest date for questions:</FormLabel>
        <TextField
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
        />
      </FormControl>

      <Autocomplete
        multiple
        options={modelOptions}
        value={modelList}
        onChange={(_, v) => setModelList(v)}
        renderInput={(params) => (
          <TextField {...params} label="Select model(s)" />
        )}
        sx={{ mb: 2 }}
      />

      <TextField
        label="Number of questions to submit"
        type="number"
        fullWidth
        value={numberOfQuestions}
        onChange={(e) => setNumberOfQuestions(Number(e.target.value))}
        sx={{ mb: 2 }}
      />

      <TextField
        label="Send notification to:"
        type="email"
        fullWidth
        value={notifiedUserEmail}
        onChange={(e) => setNotifiedUser(e.target.value.trim())}
        sx={{ mb: 2 }}
      />

      {/* <FormControl component="fieldset" sx={{ mb: 2 }}>
        <FormLabel component="legend">Evaluation Criteria</FormLabel>
        <FormGroup>
          {evaluationCriteriaOptions.map((opt) => (
            <FormControlLabel
              key={opt}
              control={
                <Checkbox
                  checked={criteria.includes(opt)}
                  onChange={handleCriteriaChange}
                  name={opt}
                />
              }
              label={opt}
            />
          ))}
        </FormGroup>
      </FormControl> */}
    </Box>
  );
};

export default FormInputs;